import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const RECALL_REACTIVATION_CONTROL_FILTERS = REPORTS_DEFAULT_FILTERS

export const RECALL_REACTIVATION_CONTROL_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'percent' | 'count'
  unitInline?: string
}> = [
  {
    id: 'recall-compliance',
    title: 'Recall Compliance',
    footer: 'Due patients scheduled / due for recall',
    format: 'percent',
  },
  {
    id: 'reactivation-rate',
    title: 'Reactivation Rate',
    footer: 'Inactive patients scheduled / total inactive',
    format: 'percent',
  },
  {
    id: 'patients-due-recall',
    title: 'Patients Due for Recall',
    footer: 'Eligible Patients',
    format: 'count',
    unitInline: 'Patients',
  },
  {
    id: 'hygiene-overdue',
    title: 'Hygiene Overdue (12+ mo)',
    footer: 'Patients not seen in 12+ months',
    format: 'count',
    unitInline: 'Patients',
  },
]

export type ProviderRecallResponseRow = {
  id: string
  provider: string
  eligible: number
  completed: number
  rate: string
}

export type HygieneOverdueRow = {
  id: string
  patientName: string
  lastHygiene: string
  daysSince: number
  phone: string
}
